import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { ArrowRight, ShieldCheck } from 'lucide-react';
import { trackAddToCart } from '../hooks/useMetaPixel';
export function PricingSection() {
  const handlePurchase = () => {
    // Track AddToCart event before redirecting
    trackAddToCart('The 14-Day Fragrance-Free Home Reset', 6.39, 'USD');
    window.open('https://www.metodolowtox.com/cart/51631184806199:1', '_blank');
  };
  return <section id="pricing-section" className="py-24 px-6 bg-[#8B9D83]" data-id="element-94">
      <div className="max-w-4xl mx-auto" data-id="element-95">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-[#F5F1E8] rounded-3xl p-10 md:p-16 shadow-2xl shadow-[#8B9D83]/20" data-id="element-96">
          <div className="grid md:grid-cols-[1fr,300px] gap-12 items-center" data-id="element-97">
            <div className="text-center md:text-left" data-id="element-98">
              <h2 className="text-3xl font-serif text-[#2D2D2D] mb-2" data-id="element-99">
                Get The Reset
              </h2>
              <div className="flex items-center justify-center md:justify-start gap-1 mb-6" data-id="element-100">
                <span className="text-2xl text-[#8B9D83] font-serif align-top mt-2" data-id="element-101">
                  $
                </span>
                <span className="text-7xl font-serif text-[#2D2D2D] font-bold" data-id="element-102">
                  6.39
                </span>
              </div>

              <p className="text-lg text-[#5A5A5A] mb-10" data-id="element-103">
                One small purchase to replace weeks of guessing, label-reading,
                and panic-switching.
              </p>

              <Button onClick={handlePurchase} className="w-full md:w-auto text-lg px-12 py-4 mb-6 shadow-xl shadow-[#D4A59A]/30" data-id="element-104">
                Download The Reset <ArrowRight className="ml-2 w-5 h-5" data-id="element-105" />
              </Button>

              <div className="flex items-center justify-center md:justify-start gap-2 text-sm text-[#8B9D83]" data-id="element-106">
                <ShieldCheck className="w-4 h-4" data-id="element-107" />
                <span data-id="element-108">Secure payment via Stripe • Instant PDF Access</span>
              </div>
            </div>

            <div className="hidden md:block" data-id="element-109">
              <img src="https://cdn.magicpatterns.com/uploads/gUXqgvrnb7NFz5L3Tjm38Z/heylloyd-image-1770145122296.png" alt="The 14-Day Fragrance-Free Home Reset ebook" className="w-full rounded-xl shadow-xl" data-id="element-110" />
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}